<template>
    <admin-layout>
        <template #header>
            <h2 class="text-xl font-semibold leading-tight text-white">
                Create new AudioBooks
            </h2>
        </template>
            <div class="w-full p-12 text-gray-700 bg-white rounded shadow-xl">
                <div class="text-center md:flex md:justify-between md:mb-4">
                    <div class="w-full md:pr-4">
                        <!-- book title -->
                        <div class="mb-4 text-3xl font-bold">
                            {{ book.title }}
                            <span v-if="book.is_paid == 1">(paid - {{ product.price }} COIN)</span>
                            <span v-if="book.is_paid == 0">(free)</span>
                        </div>
                        <!-- author name -->
                        <div class="text-lg">
                            <span class="font-semibold text-gray-700">Author Name - </span>
                            <span>{{ book.author }}</span>
                        </div>
                    </div>
                    <!-- cover image -->
                    <div class="w-full" style="text-align: -webkit-center;">
                        <img :src="book.cover_photo_url" alt="cover_image" class="w-80">
                    </div>
                </div>
                <!-- description -->
                <div class="mb-4">
                    <div class="w-full">
                        <div class="text-base font-bold text-gray-700">Description</div>
                        <div class="mt-2">{{ book.description }}</div>
                    </div>
                </div>
                <!-- chapter -->
                <div class="mb-4">
                    <div class="w-full">
                        <span class="text-base font-bold text-gray-700">Chapter List</span>
                        <div class="mt-2">
                            <div v-for="(chapter, index) in book.all_chapters" :key="chapter.id">
                                <span class="font-bold" v-if="chapter.title !== null">{{ index+1 + '.' }} {{ chapter.title }} - </span>
                                <span class="font-bold" v-else>{{ index+1 + '.' }} NO CHAPTER NAME - </span>
                                <a v-if="chapter.book_url_details !== null" :href="chapter.book_url_details.url.url">{{ chapter.book_url_details.url.url }}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </admin-layout>
</template>

<script>
    import AdminLayout from '@/Layouts/AdminLayout'

    export default {
        props: ['book', 'product'],
        components: {
            AdminLayout,
        },
        data() {
            return {}
        },
    };
</script>